import React from 'react';
import Navbar from '../site/Navbar';
import Footer from '../site/Footer';
import MobileHero from './MobileHero';
import MobileQuoteSteps from './MobileQuoteSteps';
import MobileGallery from './MobileGallery';
import MobileReviews from './MobileReviews';
import { WhyChoose, VideoSection, ServiceArea, BrandMoment, FinalCTA, FAQ } from './MobileSections';
import { useGoogleReviews } from './shared';

export default function MobileLanding() {
  const google = useGoogleReviews();
  return (
    <div data-testid="mobile-landing" className="min-h-screen bg-white text-[#111827]">
      <Navbar overlay />
      <MobileHero rating={google.rating} totalReviews={google.total_reviews} />
      <MobileQuoteSteps />
      <WhyChoose />
      <VideoSection />
      <MobileGallery />
      <ServiceArea />
      <MobileReviews data={google} />
      <BrandMoment />
      <FinalCTA />
      <FAQ />
      <Footer />
    </div>
  );
}
